module.exports = __webpack_public_path__ + "static/media/download.ee1440df.png";